
import { useRef, useState } from 'react';

export default function TextInput({ defaultValue, onChanged, placeholder, name, type = 'text', disableAutofill = true, autoComplete: autoCompleteProp, ...rest }) {
    // Stable name to avoid changing on each render (which may confuse React/browser)
    const stableName = useRef(name || `no-autofill-${Math.random().toString(36).slice(2)}`);

    // Decide autoComplete attribute for the real input. Prefer explicit prop, otherwise use safe values
    const autoComplete = typeof autoCompleteProp !== 'undefined'
        ? autoCompleteProp
        : (disableAutofill ? (type === 'password' ? 'new-password' : 'off') : undefined);

    // Manage a readOnly flag to prevent autofill until the user focuses the field.
    const { onFocus: userOnFocus, onBlur: userOnBlur, ...otherRest } = rest;
    const [isReadOnly, setIsReadOnly] = useState(!!disableAutofill);

    const handleFocus = (e) => {
        if (disableAutofill) setIsReadOnly(false);
        if (typeof userOnFocus === 'function') userOnFocus(e);
    };

    const handleBlur = (e) => {
        if (disableAutofill) setIsReadOnly(true);
        if (typeof userOnBlur === 'function') userOnBlur(e);
    };

    return (
        <>
            {disableAutofill && (
                // Hidden dummy inputs placed before the real input to trap autofill/autocomplete.
                // Browsers often try to fill the first username/password fields they find. These hidden
                // fields (with common autocomplete tokens) reduce the chance the browser fills the visible input.
                <>
                    <input
                        type="text"
                        name="prevent_autofill_username"
                        autoComplete="username"
                        tabIndex={-1}
                        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                        aria-hidden="true"
                        readOnly
                    />
                    <input
                        type="password"
                        name="prevent_autofill_password"
                        autoComplete="new-password"
                        tabIndex={-1}
                        style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                        aria-hidden="true"
                        readOnly
                    />
                </>
            )}

            <input
                {...otherRest}
                type={type}
                name={stableName.current}
                autoComplete={autoComplete}
                readOnly={isReadOnly}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={(e) => onChanged && onChanged(e.target.value)}
                defaultValue={defaultValue}
                className='form-control'
                placeholder={placeholder}
            />
        </>
    )
}
